import { FeaturePost } from '../FeaturePosts';

export const homeScreenWidgets: FeaturePost = {
  id: 'home-screen-widgets',
  cardImage: `${process.env.PUBLIC_URL}/assets/features/widgets.png`,
  image: '',
  tag: 'Widgets & shortcuts',
  date: '2026-10-06',
  title: 'Home Screen Widgets',
  subtitle: 'Log symptoms, food, notes and medications without opening the app',
  readTime: '2 min',
  content: `Sometimes you just want to log something quickly and get on with your day. Toastie's home screen widgets let you do exactly that.

#### Available widgets

- **Symptoms**: log how you're feeling in a tap
- **Food**: add a meal straight from your home screen
- **Notes**: jot down anything you want to remember
- **Medications**: add and track your medications

Widgets are available on both iOS and Android.`,
};
